import { toast } from "react-toastify"
import Authentication from "../services/authentication"
import profileServices from "../services/profile"
import { useCreditsStore } from "../store/creditsStore"
import Pages from "src/constants/pages"

export const BACK_TO_KEY = "backTo"
export function setBackToAfterLogin(pageAddress) {
  localStorage.setItem(BACK_TO_KEY, pageAddress)
}

class AuthHandler {
  #accessToken = ""
  #refreshToken = ""
  #user = undefined

  constructor() {
    if (typeof window === "undefined") return
    this.#accessToken = localStorage.getItem("access_token")
    this.#refreshToken = localStorage.getItem("refresh_token")
    try {
      this.#user = JSON.parse(localStorage.getItem("user"))
      //useStoreCredit.getState().setCredit(this.#user?.credit || 0)
      // useStoreOrganizations.getState().setOrganizations(this.#user?.organizations || [])
      useCreditsStore.getState().setCredits(this.#user?.credits || [])
    } catch (e) { }
  }

  loadUser() {
    // if (!!this.#user && (Date.now() - this.#user.lastUpdate) < FIVE_MIN) {
    //     return Promise.resolve(this.#user)
    // }
    if (!this.isLoggedIn) return Promise.reject("")
    return profileServices
      .getProfileData()
      .then(res => {
        if (res?.status === 200) {
          if (!res?.data?.succeed) {
            const err = res?.data?.message || "خطایی پیش آمده است"
            toast.error(err)
            throw err
          } else {
            const user = res?.data?.value
            user.lastUpdate = Date.now()
            // useStoreCredit.getState().setCredit(user.credit)
            //useStoreOrganizations.getState().setOrganizations(user.organizations)
            useCreditsStore.getState().setCredits(user.credits)
            refreshCredit()
            localStorage.setItem("user", JSON.stringify(user))
            this.#user = user
            return user
          }
        }
      })
      .catch(err => {
        toast.error(err || "خطایی پیش آمده است")
        throw err
      })
  }
  login(responseValue) {
    const { access_token, refresh_token } = responseValue
    localStorage.setItem("access_token", access_token)
    localStorage.setItem("refresh_token", refresh_token)
    this.#accessToken = access_token
    this.#refreshToken = refresh_token
  }
  backToBeforeLogin(router) {
    const hasBackUrl = router?.query?.backUrl
    const backTo = localStorage.getItem(BACK_TO_KEY)
    router.push(hasBackUrl || backTo || Pages.UserPanel)
    if (backTo) {
      localStorage.removeItem(BACK_TO_KEY)
    }
  }
  get user() {
    return this.#user
  }
  get accessToken() {
    return this.#accessToken
  }
  get refreshToken() {
    return this.#refreshToken
  }
  get isLoggedIn() {
    return !!this.#accessToken
  }
  clearSession() {
    this.#accessToken = ""
    this.#refreshToken = ""
    this.#user = null
    localStorage.removeItem("access_token")
    localStorage.removeItem("refresh_token")
    localStorage.removeItem("user")
    useCreditsStore.getState().setCredits([])
  }
  ensureSession() {
    if (!this.#accessToken) return Promise.resolve(false)
    if (this.#user) return Promise.resolve(true)
    return this.loadUser()
      .then(() => true)
      .catch(() => {
        this.clearSession()
        return false
      })
  }
  refresh() {
    return Authentication.refreshToken(this.#refreshToken).then(response => {
      if (response?.status !== 200 || !response?.data?.succeed) {
        toast.error("توکن منقضی شده است")
        this.logout()
        throw "failed"
      } else {
        this.login(response?.data?.value)
      }
    })
  }
  logout(router) {
    const { pathname, search } = typeof window !== "undefined" && window.location;
    let baseUrl = "/login"
    if (pathname) {
      const backUrl = encodeURIComponent(`${pathname}${search || ""}`);
      baseUrl += `?backUrl=${backUrl}`;
    }

    return Authentication.doLogout(this.#refreshToken).then(async response => {
      if (response?.status === 200) {
        if (!response?.data?.succeed) {
          toast.error(response?.data?.message)
        } else {
          this.clearSession()
          if (router) {
            await router.push(baseUrl)
          } else {
            location.href = baseUrl
          }
        }
      }
    })
  }
}
const FIVE_MIN = 1 * 60 * 1000
let refreshTimeout
function refreshCredit() {
  clearTimeout(refreshTimeout)
  refreshTimeout = setTimeout(() => {
    refreshCredit()
    authHandler.loadUser()
  }, FIVE_MIN)
}

const authHandler = new AuthHandler()
refreshCredit()

export function getFullUrl({ pathname, query }) {
  const newPathname = pathname.replace(/\/\[[^\]]+\]$/, "")
  // const search = query && Object.keys(query).length ? `?${new URLSearchParams(query).toString()}` : ""
  const search = query && Object.keys(query).length ? `${Object.values(query).map(encodeURIComponent).join("&")}` : ""

  return search ? `${newPathname}/${search}` : newPathname
}

export default authHandler
